import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { NavController, ToastController } from '@ionic/angular';
import {
  catchError,
  firstValueFrom,
  from,
  Observable,
  switchMap,
  throwError,
} from 'rxjs';

const toastInstance = (
  toastController: ToastController,
  navController: NavController,
) => {
  return toastController.create({
    message: "You don't have enough points to perform this action.",
    layout: 'stacked',
    duration: 5000,
    position: 'bottom',
    positionAnchor: 'tab-bar',
    cssClass: 'toast-points',
    buttons: [
      {
        text: 'Buy more points',
        handler: () => {
          navController.navigateForward('/legacy/join/membership');
        },
      },
      {
        text: 'Hide',
        handler() {
          toastController.dismiss();
        },
      },
    ],
  });
};

export const notEnoughPointsInterceptor: HttpInterceptorFn = (req, next) => {
  const navController = inject(NavController);
  const controller = inject(ToastController);

  const codes = [
    'not_enough_credits',
    'not enough credits to perform action',
    'not enough credits to follow entity',
    'not enough credits to moderate content',
    'not enough credits to read proposition',
    'not enough credits to vote',
    'not enough credits to boost Proposition',
    'not enough credits to create proposition',
  ];

  return next(req).pipe(
    catchError((error) => {
      const notEnough =
        error?.error?.errors &&
        error?.error?.errors[0] &&
        codes.includes(error.error.errors[0].code);
      if (notEnough) {
        return from(toastInstance(controller, navController)).pipe(
          switchMap((e) => {
            e.present();
            return throwError(error);
          }),
        );
      }
      return throwError(error);
    }),
  );
};
